export class MicrosoftProcessAdminConsentRequest{
    public adminConsent!:boolean;
    public code?:string;
    public tenantId?:string;
    public state!: string;
    public nonce!: string;
}
